import React, { useEffect, useRef, useState } from 'react';
import Select from "react-select";
import { Button, Col, Form, Input, InputGroup, InputGroupText, Row, Spinner } from "reactstrap";
import { useForm } from "react-hook-form";

import {
    ASSIGN_PRICES, CURRENCY_MXN_HEADER, CURRENCY_USD_HEADER,
    DISCOUNT_HEADER,
    PAX_TYPE, PREBUY_HEADER,
    PRICE_HEADER, REMOVE_PRICES_MANUAL_ASSIGNATION,
    SAVE,
    SAVINGS_HEADER
} from "../i18n/i18n";
import { ButtonCancel } from "../buttons/buttonsActions";
import { productService } from "../../jwt/_services/promotions/productService";

export const AssignPrice = ({
    item,
    onClose,
    updateList = null,
    promotion = null
}) => {
    const { paxes } = item
    const paxTypesOptions = !paxes ? [] : paxes.map(pax => ({
        value: pax?.pax_type,
        label: pax?.pax_type,
    }))

    const [saving, setSaving] = useState(false)
    const [selectedPaxType, setSelectedPaxType] = useState(paxTypesOptions[0])
    const [priceUSD, setPriceUSD] = useState((paxes.length == 0) ? [] : paxes.find( pax => pax?.pax_type === selectedPaxType?.value)?.prices
        .find(price => price.currency === 'USD'))
    const [priceMXN, setPriceMXN] = useState((paxes.length == 0) ? [] : paxes.find( pax => pax?.pax_type === selectedPaxType?.value)?.prices
        .find(price => price.currency === 'MXN'))

    const {register, handleSubmit, reset } = useForm({
        defaultValues: {
            priceUSD: priceUSD?.price || '0.00',
            priceDiscountUSD: priceUSD?.price_discount || '0.00',
            savingUSD: priceUSD?.saving || '0.00',
            preBuyDiscountUSD: priceUSD?.pre_buy_discount || '0.00',
            priceMXN: priceMXN?.price || '0.00',
            priceDiscountMXN: priceMXN?.price_discount || '0.00',
            savingMXN: priceMXN?.saving || '0.00',
            preBuyDiscountMXN: priceMXN?.pre_buy_discount || '0.00',
        }
    });

    const isMounted = useRef(true)

    //Actualizar la referencia
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    },[])

    const onChangeSelectedPax = item => {
        setSelectedPaxType(item)
        const newPriceUSD = paxes.find( pax => pax?.pax_type === item?.value)?.prices
            .find(price => price.currency === 'USD')
        const newPriceMXN = paxes.find( pax => pax?.pax_type === item?.value)?.prices
            .find(price => price.currency === 'MXN')

        setPriceUSD( newPriceUSD )
        setPriceMXN( newPriceMXN )
        reset({
            priceUSD: newPriceUSD?.price || '0.00',
            priceDiscountUSD: newPriceUSD?.price_discount || '0.00',
            savingUSD: newPriceUSD?.saving || '0.00',
            preBuyDiscountUSD: newPriceUSD?.pre_buy_discount || '0.00',
            priceMXN: newPriceMXN?.price || '0.00',
            priceDiscountMXN: newPriceMXN?.price_discount || '0.00',
            savingMXN: newPriceMXN?.saving || '0.00',
            preBuyDiscountMXN: newPriceMXN?.pre_buy_discount || '0.00',
        })
    }

    const onSubmit = (values, _) => {
        values = {
            ...values,
            paxType:selectedPaxType?.value,
            currency:priceUSD?.id_currency
        }

        if(promotion)
            values = {
                ...values,
                promotion: promotion?.id
            }

       setSaving(true)
        productService.assignPriceManually(item?.id, values)
            .then(result => {
                if(!result?.status)
                    return

                if(updateList)
                    updateList()

                onClose()
            })
            .catch( e => console.log("Error en la asignacion", e))
            .finally(() => {
                if(isMounted.current)
                    setSaving(false)
            })
    }

    const removeManualAssignation = () => {
        let values = {
            paxType:selectedPaxType?.value,
        }

        if(promotion)
            values = {
                ...values,
                promotion: promotion?.id
            }

        setSaving(true)
        productService.removeAssignPriceManually(item?.id, values)
            .then(result => {
                if(!result?.status)
                    return

                if(updateList)
                    updateList()

                onClose()
            })
            .catch( console.log )
            .finally(() => {
                if(isMounted.current)
                    setSaving(false)
            })
    }

    return (<div className='custom-ui-auto-width'>
        <h1>{ASSIGN_PRICES}</h1>

        <br/>
        <div style={{textAlign:'left'}}>
            <p>{PAX_TYPE}:</p>
            <Select
                value={selectedPaxType}
                options={paxTypesOptions}
                onChange={value => onChangeSelectedPax(value)}
                styles={{textAlign: 'left'}}
            />
            <br/>
            <br/>
            <Form onSubmit={ handleSubmit(onSubmit) }>
                <Row>
                    <Col><h4 style={ {textAlign:'center'} }>{CURRENCY_USD_HEADER}</h4></Col>
                    <Col><h4 style={ {textAlign:'center'} }>{CURRENCY_MXN_HEADER}</h4></Col>
                </Row>
                <Row>
                    <Col style={ { borderRight:'solid' } }>
                        <Row>
                            <Col>{PRICE_HEADER}</Col>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>$</InputGroupText>
                                    <Input
                                        type="number"
                                        step=".01"
                                        min="0.00"
                                        name="priceUSD"
                                        placeholder={''}
                                        innerRef={register}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>{DISCOUNT_HEADER}</Col>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>$</InputGroupText>
                                    <Input
                                        type="number"
                                        step=".01"
                                        min="0.00"
                                        name="priceDiscountUSD"
                                        placeholder={''}
                                        innerRef={register}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>{SAVINGS_HEADER}</Col>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>$</InputGroupText>
                                    <Input
                                        type="number"
                                        step=".01"
                                        min="0.00"
                                        name="savingUSD"
                                        placeholder={''}
                                        innerRef={register}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>{PREBUY_HEADER}</Col>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>$</InputGroupText>
                                        <Input
                                        type="number"
                                        step=".01"
                                        min="0.00"
                                        name="preBuyDiscountUSD"
                                        placeholder={''}
                                        innerRef={register}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col>
                        <Row>
                            <Col>{PRICE_HEADER}</Col>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>$</InputGroupText>
                                    <Input
                                        type="number"
                                        step=".01"
                                        min="0.00"
                                        name="priceMXN"
                                        placeholder={''}
                                        innerRef={register}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>{DISCOUNT_HEADER}</Col>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>$</InputGroupText>
                                    <Input
                                        type="number"
                                        step=".01"
                                        min="0.00"
                                        name="priceDiscountMXN"
                                        placeholder={''}
                                        innerRef={register}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>{SAVINGS_HEADER}</Col>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>$</InputGroupText>
                                    <Input
                                        type="number"
                                        step=".01"
                                        min="0.00"
                                        name="savingMXN"
                                        placeholder={''}
                                        innerRef={register}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                        <br/>
                        <Row>
                            <Col>{PREBUY_HEADER}</Col>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>$</InputGroupText>
                                    <Input
                                        type="number"
                                        step=".01"
                                        min="0.00"
                                        name="preBuyDiscountMXN"
                                        placeholder={''}
                                        innerRef={register}
                                    />
                                </InputGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <br/>
                <br/>

                <div style={{textAlign:'center'}}>
                    <ButtonCancel onClick={onClose}/>
                    &nbsp;&nbsp;
                    <Button
                        type={"submit"}
                        className="btn-add ml-auto ml-2"
                        disabled={ saving }
                    >
                        { SAVE }
                    </Button>
                    <Button
                        color="danger"
                        className="button-collapsed"
                        style={ {'height':'29px'} }
                        onClick={ removeManualAssignation }
                        disabled={ saving }
                    >
                        { REMOVE_PRICES_MANUAL_ASSIGNATION }
                    </Button>
                    {
                        saving && <>
                            <br/><br/>
                            <Spinner animation="border" size='sm' type='grow'/>
                            <Spinner animation="border" size='sm' type='grow'/>
                            <Spinner animation="border" size='sm' type='grow'/>
                        </>
                    }
                </div>
            </Form>
        </div>
    </div>)
}